<div class="modal-body content width-400">
	<div class="layout-auto-1-auto">
		<h5 class="modal-header">{{data.headerText}}</h5>
		<div>
			<p class="typo-small" *ngIf="data.description">{{data.description}}</p>
			<exg-textarea [required]="isRequired()"
			              [hintText]="isRequired() ? '* ' + getRessource('CommentRequired', {min: minCommentLength}) : ''"
			              [maxlength]="1024"
			              [(ngModel)]="comment"
			              [caption]="getRessource('CommentLabel')"
			              name="comment"></exg-textarea>

			<exg-input *ngIf="!data.commentRequired"
			           [(ngModel)]="billingDate"
			           [caption]="getRessource('BillingPeriod')"
			           name="abrechnungszeitraum"
			           type="date" [isEpoch]="true"></exg-input>
		</div>

		<div class="spawn-modal-actions">
			<button class="md-btn"
              [disabled]="!valid()"
              (click)="save()">
        {{getGlobal('Save')}}
      </button>
			<button class="md-btn"
              (click)="cancel()">
        {{getGlobal('Cancel')}}
      </button>
		</div>
	</div>
</div>
